import { render, staticRenderFns } from "./tagItemLave.vue?vue&type=template&id=62d7e1f4&scoped=true&"
import script from "./tagItemLave.vue?vue&type=script&lang=js&"
export * from "./tagItemLave.vue?vue&type=script&lang=js&"
import style0 from "./tagItemLave.vue?vue&type=style&index=0&id=62d7e1f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d7e1f4",
  null
  
)

export default component.exports